<template>
    <CHeader
      data-aos-easing="linear"
      data-aos-duration="1500"
      id="el"
      class="navbars"
    >
      <CHeaderBrand class="mx-auto" to="/">
        <img
          src="../assets/img/Logo.png"
          height="38"
          class="m-1"
        />
      </CHeaderBrand>
  
      <CDropdown color="light" class="m-2 d-sm-flex d-lg-none" :caret="false">
        <template #toggler-content>
          <CIcon name="cil-justify-center" />
        </template>
        
        <CDropdownItem to="/"> {{ $t('homepage') }} </CDropdownItem>
        <CDropdownItem href=""> {{ $t('login') }} </CDropdownItem>
        <CDropdownItem href="CreateAccount"> {{ $t('signUp') }} </CDropdownItem>
        <CDropdownItem href="">  <a href="#" @click.prevent="changeLanguage('ms')" title="Malay" class="mr-2">BM</a> </CDropdownItem>
        <CDropdownItem href="">   <a href="#" @click.prevent="changeLanguage('en')" title="English" class="ml-2">EN</a> </CDropdownItem>
      </CDropdown>
  
      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink to="/"> {{ $t('homepage') }} </CHeaderNavLink>
        </CHeaderNavItem>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-1">
          <CHeaderNavLink to="ViewTeams"> {{ $t('forClubsAndOrganization') }} </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff; font-family: 'Montserrat', sans-serif; font-weight: bold; font-size: 15px;">
            <a href="#" @click.prevent="changeLanguage('ms')" title="Malay" class="mr-2">BM</a>
            |
            <a href="#" @click.prevent="changeLanguage('en')" title="English" class="ml-2">EN</a>
          </CHeaderNavLink>
        </CHeaderNavItem>

        <CDropdown
            inNav
            class="c-header-nav-items"
            placement="bottom-end"
            add-menu-classes="pt-0"
        >
            <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                <!-- <img
                    src="img/avatars/6.jpg"
                    class="c-avatar-img "
                /> -->
                <img v-if="filepath != null" :src="filepath" height="30px" style="border-radius: 15px;"/>
                <img v-else src="img/avatars/6.jpg" height="30px" style="border-radius: 15px;"/>
                </div>
            </CHeaderNavLink>
            </template>
        
            
                <CDropdownItem
                @click="SignOut()"
                >Log Out</CDropdownItem
                >
        </CDropdown>






      </CHeaderNav>
    </CHeader>
  </template>
  
  <script>
  import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
  
  export default {
    name: "TheHeader",
    components: {
      TheHeaderDropdownAccnt,
    },
    data() {
        return {
            Name: "",
            filepath: "",
        };
    },
    async mounted() {

    this.GetInfoUser();

    },
    methods: {
      changeLanguage(lang) {
        this.$i18n.locale = lang;
      },
      GoToLogin()
      {
        this.$router.push("LoginAccount");
      },
      GoToSignUp()
      {
        this.$router.push("CreateAccount");
      },
      async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Name = this.user.name;
                    this.filepath = this.user.filePath;
                } else {
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.$router.push("/LoginAccount");
          }
        });

    },
    }
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>
  